const Teal = {
  Teal: {
    _100: '#CCFBF1',
    _500: '#14B8A6',
    _600: '#0D9488',
  },
};

export default Teal;
